<script setup>
import { computed } from 'vue';
import TextWidget from './widgets/TextWidget.vue';
import MetricWidget from './widgets/MetricWidget.vue';
import ChartWidget from './widgets/ChartWidget.vue';
import TableWidget from './widgets/TableWidget.vue';
import ConversationsListWidget from './widgets/ConversationsListWidget.vue';
import ContactsListWidget from './widgets/ContactsListWidget.vue';
import InboxStatusWidget from './widgets/InboxStatusWidget.vue';
import StatsCardsWidget from './widgets/StatsCardsWidget.vue';
import QuickActionsWidget from './widgets/QuickActionsWidget.vue';
import DriveWidget from './widgets/DriveWidget.vue';
import TimelineWidget from './widgets/TimelineWidget.vue';
import InfoPropertiesWidget from './widgets/InfoPropertiesWidget.vue';
import RecentActivitiesWidget from './widgets/RecentActivitiesWidget.vue';
import OrdersListWidget from './widgets/OrdersListWidget.vue';
import DeliveryStatusWidget from './widgets/DeliveryStatusWidget.vue';
import MapWidget from './widgets/MapWidget.vue';
import ChatWidget from './widgets/ChatWidget.vue';

const props = defineProps({
  widget: {
    type: Object,
    required: true,
  },
  widgetStyle: {
    type: Object,
    default: () => ({
      backgroundType: 'white',
      backgroundColor: '#FFFFFF',
      textColor: '#1F2937',
      textSecondaryColor: '#6B7280',
      primaryColor: '#FF8C42',
      borderColor: '#E5E7EB',
    }),
  },
});

const componentMap = {
  text: TextWidget,
  metric: MetricWidget,
  chart: ChartWidget,
  table: TableWidget,
  conversations_list: ConversationsListWidget,
  contacts_list: ContactsListWidget,
  inbox_status: InboxStatusWidget,
  stats_cards: StatsCardsWidget,
  quick_actions: QuickActionsWidget,
  drive: DriveWidget,
  timeline: TimelineWidget,
  info_properties: InfoPropertiesWidget,
  recent_activities: RecentActivitiesWidget,
  orders_list: OrdersListWidget,
  delivery_status: DeliveryStatusWidget,
  map: MapWidget,
  chat: ChatWidget,
};

const currentComponent = computed(
  () => componentMap[props.widget.type] || TextWidget
);

const currentStyle = computed(() => {
  return {
    backgroundType: 'white',
    backgroundColor: '#FFFFFF',
    textColor: '#0F172A',
    textSecondaryColor: '#64748B',
    primaryColor: '#0F172A',
    borderColor: '#F1F5F9',
    ...props.widgetStyle,
    ...(props.widget.style || {}),
  };
});
</script>

<template>
  <component
    :is="currentComponent"
    :widget="widget"
    :widget-style="currentStyle"
  />
</template>
